import React, { FC } from 'react'
import { func, string } from 'prop-types'
import styled from 'styled-components'
import { coinImage } from '../assets/coins/coins'

const BaseWrapper = styled.img`

  pointer-events: auto;
  //src: $(props => props.src);
  align-self: top;
  margin-right: 0.2em;
  align-self: center;
  justify-content: center;
  text-align: center;

  /* Tablets */
  @media (max-width: 1400px) {
    pointer-events: auto;
    //src: $(props => props.src);
    align-self: top;
    margin-right: 0.2em;
    width: 27px;
    height: 27px;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    margin-right: 0.2em;
  }
`

const SmallWrapper = styled(BaseWrapper)`
  width: 15px;
  height: 15px;
  
  /* Tablets */
  @media (max-width: 1400px) {
    width: 15px;
    height: 15px;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    width: 13px;
    height: 13px;
  }
`

const Wrapper = styled(BaseWrapper)`
  width: 27px;
  height: 27px;
  
  /* Tablets */
  @media (max-width: 1400px) {
    width: 27px;
    height: 27px;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    width: 20px;
    height: 20px;
  }
`

const LargeWrapper = styled(Wrapper)`
  width: 35px;
  height: 35px;
`

const CurrencyLogo: FC<{ src: string }> = ({ src }) => {
  return <Wrapper src={src} />
}

export const SmallCurrencyLogo: FC<{ src: string }> = ({ src }) => {
  return <SmallWrapper src={src} />
}

export const LargeCurrencyLogo: FC<{ src: string }> = ({ src }) => {
  return <LargeWrapper src={src} />
}

export default CurrencyLogo

export const Coin: FC<{ symbol: string }> = ({ symbol }) => {
  return (
    <CoinSpan>
      <Icon src={coinImage(symbol)} />
      <span>{symbol}</span>
    </CoinSpan>
  )
}
const CoinSpan = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
`

const Icon = styled.img`
  width: 27px;
  height: 27px;
  margin-right: 5px;
  text-align: center;
  vertical-align: middle;

  /* Tablets */
  @media (max-width: 1400px) {
    margin-right: 5px;
    width: 27px;
    height: 27px;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
`